import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const BannerImage = styled(Image)`
  width: 100%;
`

const TOURS_SEARCH_LINK = `/search/tours?destinationId=${ANYWHERE_PLACE_ID}&destinationName=${ANYWHERE_NAME}&flexibleNights=`

function TourCatalogueBanner() {
  const intl = useIntl()

  const altText = intl.formatMessage(
    {
      id: 'HLpa_6NxPsAWarqIUiCi',
      defaultMessage: 'Winner, Best Tour Operator, 2026 Gourmet Hotel and Travel Awards Readers’ Choice',
      description: 'Alt text for the Gourmet Hotel and Travel Awards winner banner image on the tours vertical page',
    },
  )

  return <Clickable to={TOURS_SEARCH_LINK}>
    <CSSBreakpoint min="desktop">
      <BannerImage image={{ id: 'ej8z6wzwgi6neih9m0nh' }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet" max="tablet">
      <BannerImage image={{ id: '1f4fwdkwfs8lzvqkmizv' }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <BannerImage image={{ id: 'wqc91cebsvnb0s81ymk' }} alt={altText} />
    </CSSBreakpoint>
  </Clickable>
}

export default TourCatalogueBanner
